var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            { staticClass: "p-3 bg-white", attrs: { lg: "9" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-space-between align-items-center",
                },
                [
                  _c("div", { staticClass: "font-bold" }, [
                    _vm._v("\n          お問い合わせ一覧\n        "),
                  ]),
                  _vm._v(" "),
                  _c("UserInquiryDialog", {
                    on: { inquirySubmited: _vm.getList },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "mt-3" }),
              _vm._v(" "),
              _vm._l(_vm.inquiries, function (inquiry) {
                return [
                  _c("InquiryView", {
                    key: inquiry.id + "-inquiry",
                    attrs: { inquiry: inquiry },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.toDetail(inquiry)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function () {
                            return [
                              _c("UserInquiryDialog", {
                                attrs: { inquiry: inquiry },
                                on: { inquirySubmited: _vm.getList },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", color: "red" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return function () {
                                        _vm.deleteInquiry(inquiry.id)
                                      }.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("mdi-delete"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("v-divider", { key: inquiry.id + "-divider" }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ConfirmDialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }